// 啄木鸟上报配置
try {
  document.domain = 'qq.com';
  // const report = window.Pecker('welfare2018')
  // report.inject$ajax($, 'ajax')
} catch (e) {}